import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';
import { atom } from '@podium/store';
import { ConsentStatus } from '@schibsted-nmp/advertising-shared';

export const $consentAtom = atom<ConsentStatus>(
  AtomChannels.Podlet,
  AtomTopics.Consent,
  ConsentStatus.Accepted
);
